import { render } from "./UnitToggle.vue?vue&type=template&id=1608a108&scoped=true"
import script from "./UnitToggle.vue?vue&type=script&lang=js"
export * from "./UnitToggle.vue?vue&type=script&lang=js"

import "./UnitToggle.vue?vue&type=style&index=0&id=1608a108&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1608a108"]])

export default __exports__